export enum InsureIQCoverageStatus {
  IN_REVIEW = 'In Review',
  ACTIVE = 'Active',
  EXPIRED = 'Expired',
  WATCHED = 'Watched',
}

export const InsureIQStatusStyles = {
  [InsureIQCoverageStatus.ACTIVE]: 'success',
  [InsureIQCoverageStatus.IN_REVIEW]: 'secondary',
  [InsureIQCoverageStatus.EXPIRED]: 'warning',
};
